















































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionRecipient } from "../../../../domain/workflow/reception";
import { ReceptionTypeItem } from "../../../../domain/workflow/items";
import { WorkflowCommonMixin } from "../../mixins";

@Component({
  components: {}
})
export default class ReceptionRecipientView extends Mixins(WorkflowCommonMixin) {
  @Prop()
  recipient: ReceptionRecipient;

  @Prop()
  paymentStatusList: ReceptionTypeItem[];

  get name(): string {
    return this.recipient ? this.recipient.name : "";
  }

  get relationship(): string {
    return this.recipient ? this.recipient.relationship : "";
  }

  get receiptDate(): Date {
    return this.recipient ? this.recipient.receiptDate : null;
  }

  get receiptTime(): Date {
    return this.recipient ? this.recipient.receiptTime : null;
  }

  get paymentStatus(): number {
    return this.recipient ? this.recipient.paymentStatus : null;
  }

  get paymentStatusName(): string {
    return this.paymentStatusList && this.paymentStatus
      ? Enumerable.from(this.paymentStatusList).where(p => p.id === this.paymentStatus).select(p => p.name).firstOrDefault()
      : "";
  }

  get receiptMoney(): string {
    return this.recipient ? this.recipient.receiptMoney : "";
  }

  get note(): string {
    return this.recipient ? this.recipient.note : "";
  }

}
